import { Lightning, Router } from '@lightningjs/sdk'

import { HLSJSPlayer } from '../components'

export default class TVPlayer extends Lightning.Component {
  // Lifecycle
  _firstActive() {
    this.hlsPlayer = new HLSJSPlayer({ liveDurationInfinity: true })
  }
  _active() {
    this.hlsPlayer.open(this.item.streamUrl)
    this.hlsPlayer.show()
  }
  _inactive() {
    this.hlsPlayer.stop()
    this.hlsPlayer.hide()
    this.stage.gc()
  }

  // Template
  static _template() {
    return {
      Background: {
        rect: true,
        color: 0xff000000,
        w: 1920,
        h: 1080,
        Text: {
          mount: 0.5,
          x: w => w / 2,
          y: h => h / 2,
          text: {
            text: 'Loading...',
            fontFace: 'Regular',
            fontSize: 32,
            textColor: 0xffffffff,
          },
        },
      },
    }
  }

  // Getters / Setters
  set params(args) {
    this.channel = args.channel
    this.item = args.item
  }

  // Event Handlers
  _handleBack() {
    Router.navigate('home')
    return false
  }
}
